import React, {createContext, useContext} from 'react';
import PropTypes from 'prop-types';
import RouteResolverContext from './RouteResolverContext';
import useCategory from '../hooks/useCategory';

const Context = createContext({
  category: {},
  isFetching: false,
});

export default Context;

export const CategoryContextProvider = ({children}) => {
  const {resourceId, isFetching: isFetchingResourceId} = useContext(
    RouteResolverContext,
  );

  const {data: category, isFetching} = useCategory(resourceId, {
    skip: isFetchingResourceId || !resourceId,
  });

  return (
    <Context.Provider
      value={{
        category,
        isFetching: isFetching || isFetchingResourceId,
      }}>
      {children}
    </Context.Provider>
  );
};

CategoryContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
